import dynamic from 'next/dynamic';
import React, { FC, PropsWithChildren } from 'react';

const NoSsr: FC<PropsWithChildren> = ({ children }) => (
  <React.Fragment>{children}</React.Fragment>
);

export default dynamic(() => Promise.resolve(NoSsr), {
  ssr: false
});
